<template>
  <div class="appPay">

  </div>
</template>

<script>
  import weixinService from "../../services/weixin-service.js";
  import httpService from "../../services/http-service.js";

  export default {
    data() {
      return {
        payData: {},
        PayNo: ''
      }
    },
    methods: {

    },
    created() {
      this.PayNo = new httpService().search('payno')
      new weixinService().GetMWebUrlForH5Pay({ PayNo: this.PayNo }).then(res => {
        // window.location.href = res
        if(res.ErrorCode == 0) {
            window.location.href = res.Data.MWebUrl
        } else {
            alert(res.ErrorMessage)
        }
      }, err => {
        alert('支付异常，请联系客服')
        this.$router.push({ path: '/home' })
      })
    }
  }
</script>

<style scoped>
  .appPay {
    font-size: .16rem;
    padding: .1rem;
  }
</style>


// WEBPACK FOOTER //
// src/component/pay/AppPay.vue